import React from "react";
import { CtaButton } from "../CtaButton";
import { CheckIcon } from "lucide-react";
interface Plan {
  emoji: string;
  name: string;
  featured?: boolean;
  includes: string;
  idealFor: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  value: number;
}
const PLANS: Plan[] = [{
  emoji: "🍕",
  name: "MEGAPACK 72HS™",
  includes: "6 Tomos + 6 Bonos",
  idealFor: "Quien quiere empezar a vender comida desde casa esta semana",
  oldPrice: "$65.000",
  price: "$19.999 ARS",
  cta: "→ Quiero mi Megapack 72HS",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy",
  value: 19999
}, {
  emoji: "👨‍🍳",
  name: "MEGAPACK 72HS™ MAESTRO PRO",
  featured: true,
  includes: "6 Tomos + 6 Bonos + Kit Escalamiento y Marca Personal",
  idealFor: "Quien quiere construir una marca real, crecer con sistema y escalar el negocio",
  oldPrice: "$85.000",
  price: "$27.500 ARS",
  cta: "→ Quiero el Megapack Maestro PRO",
  href: "https://advanceformuladigital.com/products/megapack-72hs-tu-negocio-de-comidas-listo-hoy-pro",
  value: 27500
}];
export function Pricing() {
  return <section id="planes" className="bg-neutral-950 py-16 px-4 border-t border-neutral-900 scroll-mt-4" data-id="element-187" data-mp="16ip74n1p6ynx">
      <div className="max-w-5xl mx-auto" data-id="element-188" data-mp="11iueof29y10r">
        <h2 className="font-display text-4xl sm:text-6xl text-white text-center uppercase mb-10" data-id="element-189" data-mp="xjvbp003seby">
          Elegí tu <span className="text-[#e10600]" data-id="element-190" data-mp="1u9uk8ug97cuj">Megapack</span>
        </h2>

        <div className="grid gap-6 md:grid-cols-2 items-start" data-id="element-191" data-mp="1pahxsatao7sh">
          {PLANS.map(p => <div key={p.name} className={`relative rounded-2xl p-7 flex flex-col ${p.featured ? "bg-black border-2 border-[#e10600] glow-red" : "bg-black border border-neutral-800"}`} data-id="element-192" data-mp="1p8ewuvqlsu8z">
              {p.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e10600] text-white font-condensed tracking-widest text-sm px-4 py-1 rounded-full" data-id="element-193" data-mp="1gbxp82hg7ehz">
                  ⭐ MÁS ELEGIDO
                </span>}
              <div className="text-4xl mb-2" data-id="element-194" data-mp="6btrfdskxh8b">{p.emoji}</div>
              <h3 className="font-display text-2xl text-white uppercase leading-none" data-id="element-195" data-mp="6cd34crmz9dw">{p.name}</h3>
              <p className="font-condensed text-lg text-[#e10600] tracking-wide mt-2" data-id="element-196" data-mp="baelevh8n4ob">{p.includes}</p>

              <div className="mt-4 flex items-start gap-2 text-sm text-neutral-400" data-id="element-197" data-mp="3tg9otys6rsip">
                <CheckIcon className="w-4 h-4 text-[#e10600] mt-0.5 flex-shrink-0" data-id="element-198" data-mp="1bfmw5q6spf1" />
                <span data-id="element-199" data-mp="3jporeeo90u1d"><strong className="text-neutral-300" data-id="element-200" data-mp="3jpy799fkxktc">Ideal para:</strong> {p.idealFor}</span>
              </div>

              <div className="mt-6" data-id="element-201" data-mp="3oj11zkw3f0b4">
                <span className="text-neutral-500 line-through text-xl" data-id="element-202" data-mp="39sk58euekykk">{p.oldPrice}</span>
                <div className="font-display text-5xl text-white mt-1" data-id="element-203" data-mp="39qphytvnsudb">{p.price}</div>
              </div>

              <div className="mt-6 mt-auto pt-6" data-id="element-204" data-mp="30rvohcdmkk3z">
                <CtaButton href={p.href} trackName={p.name} trackValue={p.value} variant={p.featured ? "primary" : "dark"} pulse={p.featured} data-id="element-205" data-mp="30t6qb6nifhsg">
                  {p.cta}
                </CtaButton>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}